import React from "react"
import styled from "styled-components"

import Single from "./Single"

const Features = ({ features }) => {
  return (
    <Container>
      {!!features &&
        features.map((feat, index) => {
          return <Single key={index} {...feat} count={features.length} />
        })}
    </Container>
  )
}

export default Features

const Container = styled.div`
  @media (min-width: 940px) {
    flex-direction: row;
  }
  flex-direction: column;
  display: flex;
  padding: 5%;
  @media (min-width: 800px) {
    padding: 30px;
  }
`
